var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('h4',{class:_vm.showDarkBrand ? 'dark-color' : 'green-color',attrs:{"id":"prompt"},on:{"click":_vm.goToEntrance}},[_vm._v(_vm._s(_vm.labels.entrance.prompt[_vm.language]))])])}
var staticRenderFns = []

export { render, staticRenderFns }